import { useMutation, MutationResult } from "@apollo/client";
import React from "react";
import environment from "../../env";
import { checkTokenizationStatusSchema } from "../../graphql/mutations/checkTokenizationStatus";
import { createTokenizationSchema } from "../../graphql/mutations/createTokenization";

export const useLookupAndTokenization = (
  email: string,
  phoneNumber: string,
  type: "stripe" | "tink" = "stripe"
): [MutationResult<any>, Function] => {
  const variables = {
    variables: { ...environment.paymentService },
  };
  const [checkTokenizationStatus, request] = useMutation(
    checkTokenizationStatusSchema,
    variables
  );

  const [createTokenization, tRequest] = useMutation(
    createTokenizationSchema,
    variables
  );

  const payload = {
    variables: {
      input: { emailOrPhone: { email, phoneNumber } },
    },
    context: {
      credentials: "include", // Add credentials here
    },
  };
  const getStatus = () => {
    checkTokenizationStatus(payload);
  };
  React.useEffect(getStatus, []);

  React.useEffect(() => {
    const checkTokenizationStatus =
      request.data?.checkTokenizationStatus ||
      request.data?.data?.checkTokenizationStatus;
    if (checkTokenizationStatus && !request.loading && request.called) {
      if (
        checkTokenizationStatus === "Account not found" ||
        checkTokenizationStatus?.status !== "active"
      ) {
        createTokenization({
          variables: {
            input: {
              emailOrPhone: { email, phoneNumber },
              type: type === "tink" ? 1 : undefined,
            },
          },
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [request.data]);

  const checkTokenizationStat =
    request.data?.checkTokenizationStatus ||
    request.data?.data?.checkTokenizationStatus;

  if (
    typeof checkTokenizationStat !== "string" &&
    checkTokenizationStat?.status === "active"
  ) {
    return [request, getStatus];
  }
  return [tRequest, getStatus];
};
